
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCashbackStatus = () => {
  return useQuery({
    queryKey: ['cashback-status'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return { isEnabled: false };

      const { data: activeRule } = await supabase
        .from('cashback_rules')
        .select('id')
        .eq('user_id', user.id)
        .eq('is_active', true)
        .maybeSingle();

      return {
        isEnabled: !!activeRule,
      };
    },
    refetchInterval: 5000, // Atualizar a cada 5 segundos
  });
};
